import { BrowserRouter, Route, Switch } from "react-router-dom";
import { Provider } from "react-redux";

// redux-store
import { ReduxStore } from "../Redux/Store";

import ScrollToTop from "../Config/ScrollToTop";

import Home from "../Pages/Home/Home";
import About from "../Pages/About";
import BusinessCategory from "../Pages//BusinessCategory/BusinessCategory";
import AllCategories from "Pages/Category/AllCategories";
import NotFound from "Pages/NotFound/NotFound";
import DownloadApp from "Pages/DownloadApp/DownloadApp";
import ToastHandler from "CommonComponents/ToastHandler";
import Blog from "Pages/Blogs/Blogs";
import SingleBlog from "Pages/SingleBlog/SingleBlog";
import DownloadMerchantApp from "Pages/DownloadMerchantApp/DownloadMerchantApp";
import SignIn from "Pages/SignIn";
import SignUp from "Pages/SignUp";
import Otp from "Pages/Otp";
import ChashBackWithDaapapp from "Pages/ChashBackWithDaapapp";
function Router() {
  return (
    <Provider store={ReduxStore}>
      <BrowserRouter>
        <ScrollToTop>
          <Switch>
            <Route from={"/category"} exact component={BusinessCategory} />
            <Route from={"/sign-in"} exact component={SignIn} />
            {/* <Route from={"/sign-up"} exact component={SignUp} /> */}
            <Route from={"/otp"} exact component={Otp} />
            <Route from={"/category/:id"} component={AllCategories} />
            <Route from={"/sub_category/:subId"} component={AllCategories} />
            <Route from={"/about"} component={About} />
            <Route from={"/download"} component={DownloadApp} />
            <Route from={"/dl-merchant-app"} component={DownloadMerchantApp} />
            <Route from={"/dl"} component={DownloadApp} />
            <Route from={"/d"} component={DownloadApp} />
            <Route from={"/blogs"} component={Blog} />
            <Route from={"/blog/:id"} component={SingleBlog} />
            <Route
              from={"/کش-بک-با-داپ-اَپ"}
              component={ChashBackWithDaapapp}
            />
            <Route exact from={"/"} component={Home} />
            <Route component={NotFound} />
          </Switch>
        </ScrollToTop>
      </BrowserRouter>
      <ToastHandler />
    </Provider>
  );
}

export default Router;
